import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BaseFileExtension } from '../../../../enums/base-available-file-type.enum';
import { PdfSrcType } from '../../../../types/base-pdf-src.type';

@Component({
  selector: 'base-document-viewer',
  templateUrl: './base-document-viewer.component.html',
})
export class BaseDocumentViewerComponent implements OnInit {
  @Input() src: Blob | null = null;
  @Input() fileName = '';
  @Input() fileType: string = BaseFileExtension.pdf;
  @Input() modalRef: NgbModalRef;
  @Input() isCustomBodyText = false;
  @Input() customBodyText: string;
  @Input() hideBorder = false;
  @Input() height = '90vh';

  pdfSrc: PdfSrcType | null = null;
  imageSrc: SafeUrl | null = null;
  baseFileExtension = BaseFileExtension;

  @Output() downloadImage = new EventEmitter();

  constructor(private sanitizer: DomSanitizer) {}

  get isPdf() {
    return this.fileExtension === BaseFileExtension.pdf;
  }

  get fileExtension() {
    if (!this.fileType) return BaseFileExtension.pdf;
    const normalized = this.fileType.trim().toLowerCase();
    return (normalized.includes('/') ? normalized.split('/').pop()! : normalized) as BaseFileExtension;
  }

  ngOnInit() {
    if (!this.src) {
      return;
    }

    if (this.isPdf) {
      this.pdfSrc = this.src;
      this.imageSrc = null;
    } else {
      this.imageSrc = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.src));
      this.pdfSrc = null;
    }
  }
}
